import { render, staticRenderFns } from "./loadShimmer.vue?vue&type=template&id=2a129a5a&scoped=true&"
import script from "./loadShimmer.vue?vue&type=script&lang=ts&"
export * from "./loadShimmer.vue?vue&type=script&lang=ts&"
import style0 from "./loadShimmer.vue?vue&type=style&index=0&id=2a129a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a129a5a",
  null
  
)

component.options.__file = "loadShimmer.vue"
export default component.exports